import React from 'react';

const OverSummary = ({ thisOver, onEditClick }) => {
    return (
        <div className="over-summary">
            <strong>This Over:</strong>
            {thisOver.map((ball) => (
                <span key={ball.temp_id || ball.id} className="ball-bubble" onClick={() => onEditClick(ball)}>
                    {ball.is_wicket ? 'W' : ball.runs_scored}
                </span>
            ))}
        </div>
    );
};

export default OverSummary;
